export function layerIsLoading(layerState: any, layerId: string) {
    return layerState[layerId] && layerState[layerId].isLoading;
}
